import React, { useState, useEffect } from 'react';
import { Settings, Save, RefreshCw } from 'lucide-react';
import api from '../../lib/api';
import { toast } from 'sonner';

function ConfigRow({ item, onSave, saving }) {
  const [editValue, setEditValue] = React.useState(item.value);
  return (
    <div style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-primary)', borderRadius: 'var(--radius-lg)', padding: 'var(--space-lg)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16 }}>
      <div style={{ flex: 1 }}>
        <div style={{ color: 'var(--text-primary)', fontSize: 14, fontWeight: 600 }}>{item.key.replace(/_/g, ' ')}</div>
        <div style={{ color: 'var(--text-tertiary)', fontSize: 11, marginTop: 2 }}>{item.description}</div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <input type="number" step="0.01" value={editValue} onChange={e => setEditValue(e.target.value)} style={{ width: 80, padding: '8px 12px', background: 'var(--input-bg)', border: '1px solid var(--input-border)', borderRadius: 8, color: 'var(--text-primary)', fontSize: 14, textAlign: 'center', outline: 'none' }} />
        <button onClick={() => onSave(item.key, editValue)} disabled={saving[item.key]} style={{ padding: '8px 14px', borderRadius: 8, border: 'none', background: saving[item.key] ? 'var(--bg-tertiary)' : 'var(--accent-gradient)', color: saving[item.key] ? 'var(--text-tertiary)' : '#fff', cursor: saving[item.key] ? 'default' : 'pointer', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4 }}>
          {saving[item.key] ? <RefreshCw size={12} /> : <Save size={12} />}
          {saving[item.key] ? '...' : 'Save'}
        </button>
      </div>
    </div>
  );
}

export default function ConfigRates() {
  const [config, setConfig] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState({});

  useEffect(() => { loadConfig(); }, []);

  const loadConfig = async () => {
    try {
      const res = await api.get('/api/admin/config');
      setConfig(res.data.config || []);
    } catch {} finally { setLoading(false); }
  };

  const handleSave = async (key, value) => {
    setSaving(prev => ({ ...prev, [key]: true }));
    try {
      await api.put(`/api/admin/config/${key}`, { value });
      toast.success(`${key} updated`);
      loadConfig();
    } catch { toast.error('Failed to update'); }
    finally { setSaving(prev => ({ ...prev, [key]: false })); }
  };

  if (loading) return <div style={{ textAlign: 'center', padding: 60 }}><div className="loader"></div></div>;

  return (
    <div className="page-content" style={{ maxWidth: '100%' }}>
      <div style={{ marginBottom: 'var(--space-xl)' }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 4px', display: 'flex', alignItems: 'center', gap: 10 }}>
          <Settings size={22} color="var(--accent-primary)" /> Config & Rates
        </h2>
        <p style={{ color: 'var(--text-tertiary)', fontSize: 13, margin: 0 }}>Payment processing fees and default values</p>
      </div>
      <div style={{ display: 'grid', gap: 'var(--space-md)', maxWidth: 600 }}>
        {config.map(item => (
          <ConfigRow key={item.key} item={item} onSave={handleSave} saving={saving} />
        ))}
      </div>
    </div>
  );
}
